module["exports"] = [
  "Gruppen",
  "AB",
  "HB",
  "Group",
  "Investment",
  "Kommanditbolag",
  "Aktiebolag"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/company/suffix.js
 ** module id = 991
 ** module chunks = 0
 **/